module.exports = {"global":{"event-name":{"short":"25hBD"}}}